import { render, staticRenderFns } from "./ModalSendThankYou.vue?vue&type=template&id=16896042&scoped=true&"
import script from "./ModalSendThankYou.vue?vue&type=script&lang=js&"
export * from "./ModalSendThankYou.vue?vue&type=script&lang=js&"
import style0 from "./ModalSendThankYou.vue?vue&type=style&index=0&id=16896042&lang=scss&scoped=true&"
import style1 from "./ModalSendThankYou.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16896042",
  null
  
)

export default component.exports